export default async function authenticateAdmin(email, password) {
    // sleep 1 second
    await new Promise(resolve => setTimeout(resolve, 1000));
    if (email === "admin" && password === "admin") {
        return true;
    }
    return false;
}
